export default __webpack_public_path__ + "static/media/resource-email-icon.30cdff83.svg";